import { Col, Row } from "antd";
import dayjs from "dayjs";
import { CompanyList } from "@/shared/ui";
import type { CompanyItem } from "@/shared/ui";
import { fallbackString } from "@shared/utils";
import "./section-third-details.scss";

interface SectionThirdDetailsProps {
  workType?: string;
  workDate?: string;
  workName?: string;
  locationDescription?: string;
  workCondition?: string | null;
  companyList?: CompanyItem[] | null;
}

export const SectionThirdDetails = ({
  workType,
  workDate,
  workName,
  locationDescription,
  workCondition,
  companyList,
}: SectionThirdDetailsProps) => {
  const workTypeLabel = workType === "WORK" ? "Работа" : "Испытание";
  const formattedDate = workDate ? dayjs(workDate).format("DD.MM.YYYY") : "-";

  return (
    <div className="section-third-details">
      <div className="section-third-details__section">
        <div className="section-third-details__title">Основная информация</div>

        <div className="section-third-details__table">
          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Тип работы
            </Col>
            <Col span={16} className="section-third-details__text">
              {workTypeLabel}
            </Col>
          </Row>

          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Дата выполнения работ
            </Col>
            <Col span={16} className="section-third-details__text">
              {fallbackString(formattedDate)}
            </Col>
          </Row>

          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Наименование работы
            </Col>
            <Col span={16} className="section-third-details__text">
              {fallbackString(workName)}
            </Col>
          </Row>

          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Местоположение
            </Col>
            <Col span={16} className="section-third-details__text">
              {fallbackString(locationDescription)}
            </Col>
          </Row>

          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Условия производства работ
            </Col>
            <Col span={16} className="section-third-details__text">
              {fallbackString(workCondition)}
            </Col>
          </Row>

          <Row className="section-third-details__row">
            <Col span={8} className="section-third-details__label">
              Организации, выполнившие работу
            </Col>
            <Col span={16} className="section-third-details__text">
              <CompanyList companies={companyList} separator="comma" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

